// extracted by mini-css-extract-plugin
module.exports = {"bold":"style__bold__MehUm","button":"style__button__n10fA","sendInfo":"style__sendInfo__Kk4bj","subNote":"style__subNote__NMpwI"};